<template>
	<div class="project-application-process">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content pb-0">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb></Breadcrumb>
										<!-- <ol class="breadcrumb m-0">
											<li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
											<li class="breadcrumb-item">课题申报</li>
											<li class="breadcrumb-item">课题申报</li>
											<li class="breadcrumb-item active">课题申报流程</li>
										</ol> -->
									</div>
									<h3 class="header-title mb-3">
										课题申报流程
										<span class="ml-2">（<span class="text-danger">*</span>表示必填）</span>
									</h3>
								</div> <!-- end page-title-box -->
							</div> <!-- end col-->
						</div>
					</div>
				</div>
			</div>
		
			<div class="wrapper pt-0">
				<!-- ========== Left Sidebar Start ========== -->
				<div class="left-side-menu">
					<!--- Sidemenu -->
					<ul class="metismenu side-nav sidenav-three">
						<!-- <li class="side-nav-title side-nav-item text-left mb-3">申报号：</li> -->
		
						<li class="side-nav-item mb-2" v-for="(item,index) in menuList" :key="index" @click="changeMenuIndex(index)">
							<a href="javascript: void(0);" class="side-nav-link clearfix" :class="{active:curMenuIndex === index}">
								<i>{{index | getStep}}</i>
								<span>{{item}}<span class="ml-1 text-danger">*</span></span>
							</a>
						</li>
					</ul>
					
					<div class="tip">
						说明：新申报或被审核退回修改的课题，请修改后务必点击<span class="red"> “第三步” </span>底部的<span class="red"> “保存并提交” </span>按钮，才能提交至上级部门进行审批！
					</div>
					<!-- Sidebar -left -->
					<!-- <div class="side-Comment">
						<button type="button" class="btn btn-success" @click="submit">提交课题申报</button>
						<p class="text-danger">说明：申报信息填写完毕后，务必点击“提交课题申报”按钮。</p>
					</div> -->
				</div>
				<!-- Left Sidebar End -->
		
				<div class="content-page content-right">
					<!-- 三级级导航 -->
					<a class="button-menu-mobile disable-btn">
						<span class="dripicons-checklist"></span>
						<span class="ml-4">申报号</span>
					</a>
					<ProcessOne @finish="finishProcessOne" :topicDetail="topicDetail" :projectApplicationId="projectApplicationId" v-show="curMenuIndex === 0"></ProcessOne>
					<ProcessTwo @preStep="preStepToOne" @finish="finishProcessTwo" :topicDetail="topicDetail" :projectApplicationId="projectApplicationId" v-show="curMenuIndex === 1"></ProcessTwo>
					<ProcessThree :oneStepIsFinish="oneStepIsFinish" :twoStepIsFinish="twoStepIsFinish" @preStep="preStepToTwo" :topicDetail="topicDetail" :projectApplicationId="projectApplicationId" v-show="curMenuIndex === 2"></ProcessThree>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
	import ProcessOne from './components/ProjectApplicationProcessOne.vue'
	import ProcessTwo from './components/ProjectApplicationProcessTwo.vue'
	import ProcessThree from './components/ProjectApplicationProcessThree.vue'
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'
	import { getTopicsDeclarationById } from '@/api/after/projectApplication.js'
	export default {
		components:{
			ProcessOne,
			ProcessTwo,
			ProcessThree,
			Breadcrumb
		},
		data(){
			return {
				menuList:['课题基本信息','负责人及成员信息','课题申报书内容'],
				curMenuIndex:0,
				projectApplicationId:'',
				topicDetail:null,//当前课题详情
				oneStepIsFinish:false,//是否完成第一步表单
				twoStepIsFinish:false,//是否完成第二步表单
			}
		},
		filters:{
			getStep(val){
				switch(val){
					case 0:
						return '第一步：'
						break;
					case 1:
						return '第二步：'
						break;
					case 2:
						return '第三步：'
						break;
					default:
						break;
				}
			}
		},
		async created() {
			if (this.$route.query.topicId) {
				this.projectApplicationId = this.$route.query.topicId
				await this.getTopicsDeclarationInfo()
				this.calcCurStep()
			}
		},
		methods:{
			async getTopicsDeclarationInfo(){
				const res = await getTopicsDeclarationById(this.$route.query.topicId)
				if (res.code == 200) {
					console.log('获取课题详情',res.data);
					let obj = res.data
					// 处理数据
					if (obj.coreMember) {
						obj.coreMember = obj.coreMember.split(',')
					}
					if (obj.keywords) {
						obj.keywords = obj.keywords.split(',')
					}else{
						obj.keywords = []
					}
					if (obj.expectedResearchResults) {
						obj.expectedResearchResults = obj.expectedResearchResults.split(',')
					}else{
						obj.expectedResearchResults = []
					}
					this.topicDetail = obj
					// 根据数据判断第一二步是否已完成
					if (obj.name) {
						this.oneStepIsFinish = true
					}
					if (obj.nation) {
						this.twoStepIsFinish = true
					}
				}else{
					this.$message.error(res.data)
				}
			},
			
			// 判断当前在第几步
			calcCurStep(){
				// 判断当前在第几步
				if ([2,5].includes(this.topicDetail.type)) {
					this.curMenuIndex = 0
				}else{
					if (!this.topicDetail.name) {
						this.curMenuIndex = 0
					}else if (this.topicDetail.gender!==null) {
						this.curMenuIndex = 1
					}
				}
			},
			
			// 切换导航栏
			switchTab(index){
				this.curMenuIndex = index
			},
			// 完成第一步骤
			finishProcessOne(id){
				this.curMenuIndex = 1
				this.projectApplicationId = id
				this.oneStepIsFinish = true
				if (this.$route.query.topicId) {
					this.getTopicsDeclarationInfo()
				}
			},
			// 完成进度二
			finishProcessTwo(id){
				this.curMenuIndex = 2
				this.projectApplicationId = id
				this.twoStepIsFinish = true
				
				if (this.$route.query.topicId) {
					this.getTopicsDeclarationInfo()
				}
			},
			// 上一步到第一步
			preStepToOne(projectApplicationId){
				this.projectApplicationId = projectApplicationId
				this.curMenuIndex = 0
			},
			// 上一步到第二步
			preStepToTwo(projectApplicationId){
				this.projectApplicationId = projectApplicationId
				this.curMenuIndex = 1
			},
			changeMenuIndex(index){
				this.curMenuIndex = index
			}
		}
	}
</script>

<style scoped lang="scss">
	.tip{
		padding: 0 20px;
	}
.red{
	color: red;
}
.side-nav .side-nav-link{
	padding: 15px 15px;
}
.side-nav .side-nav-link i{
	width: 60px;
}
</style>